import type { FieldValues } from "react-hook-form";
import { FormComponent } from "../FormComponent";
import { FormCheckboxGroup, type FormCheckboxGroupProps } from "../fields/FormCheckboxGroup";
import type { FormComponentProps } from "../types";

export type FormCheckboxGroupComponentProps<TFieldValues extends FieldValues> =
	FormComponentProps<TFieldValues> & Omit<FormCheckboxGroupProps<TFieldValues>, "control">;

export const FormCheckboxGroupComponent = <TFieldValues extends FieldValues>(
	props: FormCheckboxGroupComponentProps<TFieldValues>,
) => {
	const { formMethods, className, ...restProps } = props;
	const { control } = formMethods;
	return (
		<FormComponent {...props} className={undefined}>
			<FormCheckboxGroup control={control} className={className} {...restProps} />
		</FormComponent>
	);
};
